import {Component, Input} from '@angular/core';

export type MessageType = 'error' | 'info';

export interface Message {
  type: MessageType;
  message: string;
}

@Component({
  selector: 'app-validation-messages-panel',
  imports: [],
  templateUrl: './validation-messages-panel.component.html',
  styleUrl: './validation-messages-panel.component.css'
})
export class ValidationMessagesPanelComponent {
  @Input() messages: Message[] = [];

  @Input()
  showSuccessWhenEmpty = false;

  @Input()
  successMessage = 'Your changes have been saved.';

  get normalizedMessages(): Message[] {
    if (this.messages?.length) return this.messages;
    if (this.showSuccessWhenEmpty) {
      return [{type: 'info', message: this.successMessage}];
    }
    return [];
  }
}

